module.exports = __webpack_public_path__ + "static/media/34.8c53395a.jpg";